(function () {
  'use strict';

  const animalNames = {
    chickens: 'Chickens', cats: 'Cats', rabbits: 'Rabbits',
    dogs: 'Dogs', birds: 'Birds', 'small-pets': 'Guinea pigs'
  };
  const rangeNames = {
    chickens: 'Chicken coops', cats: 'Cat enclosures', rabbits: 'Rabbit hutches',
    dogs: 'Dog kennels', birds: 'Bird aviaries', 'small-pets': 'Guinea pig hutches'
  };
  const singularNames = { chickens: 'chicken', cats: 'cat', rabbits: 'rabbit', dogs: 'dog', birds: 'bird', 'small-pets': 'guinea pig' };

  const advice = {
    chickens: 'Compare the sheltered area, run and access. Outside dimensions do not establish flock capacity.',
    cats: 'Compare the enclosure layout, openings and access for your cat. Check the product details before deciding where to place it.',
    rabbits: 'Plan sheltered housing and exercise space together. Outside dimensions are not usable living space.',
    dogs: 'Check the internal space and doorway against your dog’s measurements. Outside dimensions alone cannot confirm fit.',
    birds: 'Check usable flight space and species-specific mesh and materials before choosing an aviary.',
    'small-pets': 'Check usable floor space, sheltered area and access between levels for your guinea pigs.'
  };

  function select(models, state) {
    if (!state.animal) return { confirmed: [], unmeasured: [] };
    const candidates = models.filter((model) =>
      model.animal === state.animal && Boolean(Number(model.accessory)) === (state.kind === 'accessory')
    );
    const max = Number(state.maxCm), width = Number(state.widthCm);
    if (!(max > 0) && !(width > 0)) return { confirmed: candidates, unmeasured: [] };
    const known = model => Number(model.length)>0 && (!(width>0)||Number(model.width)>0);
    const fits = model => {
      const l=Number(model.length)/10,w=Number(model.width)/10;
      if(max>0&&width>0)return (l<=max&&w<=width)||(w<=max&&l<=width);
      return max>0?l<=max:w<=width;
    };
    return {
      confirmed: candidates.filter(model=>known(model)&&fits(model)),
      unmeasured: candidates.filter(model=>!known(model))
    };
  }

  function previewUrl(base, current, handle, animal) {
    const url = new URL(base, current);
    const source = new URL(current);
    ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
      if (source.searchParams.has(key)) url.searchParams.set(key, source.searchParams.get(key));
    });
    if (handle) url.searchParams.set('model', handle);
    else if (animal) url.searchParams.set('cw-animal', animal);
    return url.pathname + url.search + url.hash;
  }

  function reason(model, maxCm, unmeasured) {
    if (unmeasured) return 'Outside length to be confirmed. Compare the full product details before ordering.';
    const length = Number(model.length);
    if (length > 0 && maxCm) return `${Math.round(length / 10)} cm outside length, within your ${maxCm} cm limit.`;
    if (length > 0) return `${Math.round(length / 10)} cm outside length.`;
    return 'Outside dimensions to be confirmed. Compare the full product details.';
  }

  function init(root) {
    if (root.dataset.cwFinderReady === 'true') return;
    root.dataset.cwFinderReady = 'true';
    let models;
    try { models = JSON.parse(root.querySelector('[data-cw-find-data]').textContent); }
    catch (_) { models = []; }
    const state = { animal: '', kind: 'housing', maxCm: '', widthCm:'', number:'', stage:0 };
    const $ = (selector) => root.querySelector(selector);
    const animals = $('[data-cw-animals]');
    const refine = $('[data-cw-refine]');
    const maxInput = $('[data-cw-max]');
    const cards = $('[data-cw-cards]');
    const back = $('[data-cw-back]');

    function card(model, unmeasured) {
      const wrapper=document.createElement('article');wrapper.className='cw-find__product';
      const link = document.createElement('a');
      link.className = 'cw-find__card';
      link.href = previewUrl(root.dataset.catalogueUrl, window.location.href, model.handle, '');
      const image = document.createElement('img');
      image.src = model.image;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 280;
      image.height = 280;
      const body = document.createElement('span');
      body.className = 'cw-find__card-copy';
      const title = document.createElement('strong');
      title.textContent = model.title;
      const detail = document.createElement('small');
      detail.textContent = state.widthCm && !unmeasured ? `${Number(model.length)/10} × ${Number(model.width)/10} cm outside footprint. Fits your space in at least one orientation.` : reason(model, state.maxCm, unmeasured);
      const action = document.createElement('span');
      action.className = 'cw-find__card-action';
      action.textContent = model.purchaseEnabled===0?'View product':'Open product & add to bag';
      body.append(title, detail, action);
      link.append(image, body);
      const add=document.createElement('button');add.type='button';add.className='cw-find__add';
      add.textContent=model.purchaseEnabled===0?'Not available to add':'Add to bag';add.disabled=model.purchaseEnabled===0;
      const message=document.createElement('span');message.className='cw-find__bag-message';message.setAttribute('role','status');
      function addOnce(){
        if(add.dataset.added==='true')return true;
        if(window.CWDemoCart?.add(model.handle)!==true){message.textContent='Could not add this item. Open the product to try again.';return false;}
        add.dataset.added='true';add.textContent='Added ✓';message.textContent='In your preview bag. Keep exploring or open the product.';return true;
      }
      add.addEventListener('click',addOnce);
      link.addEventListener('click',event=>{if(model.purchaseEnabled===0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;addOnce();});
      wrapper.append(link,add,message);return wrapper;
    }

    function paint() {
      root.dataset.findStage=String(state.stage);
      const chosen = Boolean(state.animal);
      animals.hidden = state.stage!==0;
      $('[data-cw-household]').hidden=state.stage!==1;
      refine.hidden = state.stage<2;
      back.hidden = state.stage===0;
      $('[data-cw-step-label]').textContent = ['1 / Choose your animal','2 / Your household','3 / Your space','Your shortlist'][state.stage];
      $('[data-cw-household-title]').textContent=state.animal?`How many ${animalNames[state.animal].toLowerCase()} are you housing?`:'How many animals are you housing?';
      cards.replaceChildren();
      const count = $('[data-cw-count]');
      const all = $('[data-cw-all]');
      const advisory = $('[data-cw-advice]');
      const status = $('[data-cw-status]');
      if(chosen){
        $('[data-cw-selected]').textContent=`Shopping for ${animalNames[state.animal].toLowerCase()}`;
        $('[data-cw-kind-wrap]').hidden=!models.some(m=>m.animal===state.animal&&Number(m.accessory));
        root.querySelectorAll('[data-cw-kind]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.cwKind===state.kind)));
      }
      if(state.stage===1||state.stage===2){
        $('[data-cw-results-title]').textContent=state.stage===1?'Tell us about your animals':'Have a spot in mind?';
        status.textContent=state.stage===1?'Next, we will check the space you have available.':'Add your measurements, or leave them blank to explore the full range.';
        count.hidden=true;all.hidden=true;advisory.hidden=true;return;
      }
      if (!chosen) {
        $('[data-cw-results-title]').textContent = 'Choose an animal to begin';
        count.hidden = true;
        all.hidden = true;
        advisory.hidden = true;
        status.textContent = 'Browse the housing selected for your animal. No details required.';
        return;
      }

      const name = animalNames[state.animal];
      $('[data-cw-selected]').textContent = `Shopping for ${name.toLowerCase()}`;
      $('[data-cw-results-title]').textContent = state.kind === 'accessory' ? `${name === 'Chickens' ? 'Chicken' : 'Bird'} accessories` : rangeNames[state.animal];
      advisory.hidden = false;
      advisory.textContent = (state.number ? `Planning for ${state.number} ${Number(state.number)===1?singularNames[state.animal]:name.toLowerCase()}. `:'') + 'These options match your animal and listed outside measurements, not a verified animal capacity. '+advice[state.animal];
      const hasAccessories = models.some((model) => model.animal === state.animal && Number(model.accessory));
      $('[data-cw-kind-wrap]').hidden = !hasAccessories;
      root.querySelectorAll('[data-cw-kind]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.cwKind === state.kind));
      });
      const { confirmed, unmeasured } = select(models, state);
      count.hidden = false;
      count.textContent = String(confirmed.length);
      if (state.maxCm || state.widthCm) {
        status.textContent = confirmed.length
          ? `${confirmed.length} options within your available space.`
          : 'No measured options fit those limits. Change the measurements or choose Skip measurements.';
      } else {
        status.textContent = `${confirmed.length} ${state.kind === 'accessory' ? 'accessories' : 'housing options'} in the selected range.`;
      }
      confirmed.forEach((model) => cards.append(card(model, false)));
      if (unmeasured.length) {
        const heading = document.createElement('h4');
        heading.className = 'cw-find__unmeasured';
        heading.textContent = 'Length to confirm';
        cards.append(heading);
        unmeasured.forEach((model) => cards.append(card(model, true)));
      }
      all.hidden = false;
      const collection={chickens:'chicken-coops',cats:'cat-enclosures',rabbits:'rabbit-hutches',dogs:'dog-kennels',birds:'bird-aviaries','small-pets':'guinea-pig-hutches'}[state.animal];
      all.href = previewUrl(root.dataset.catalogueUrl.replace(/\/all\/?$/, '/'+collection), window.location.href, '', '');
      all.textContent = `Browse all ${singularNames[state.animal]} products`;
    }

    root.querySelectorAll('[data-cw-animal]').forEach((button) => button.addEventListener('click', () => {
      state.animal = button.dataset.cwAnimal;
      state.kind = 'housing';
      state.maxCm = '';
      state.widthCm='';state.number='';state.stage=1;
      $('[data-cw-number]').value='';$('[data-cw-width]').value='';
      $('[data-cw-number-error]').hidden=true;
      maxInput.value = '';
      paint();
      $('[data-cw-step-label]').setAttribute('tabindex','-1');$('[data-cw-step-label]').focus({preventScroll:true});
    }));
    root.querySelectorAll('[data-cw-kind]').forEach((button) => button.addEventListener('click', () => {
      state.kind = button.dataset.cwKind;
      paint();
    }));
    maxInput.addEventListener('input', () => {
      state.maxCm = Number(maxInput.value) > 0 ? maxInput.value : '';
    });
    $('[data-cw-width]').addEventListener('input',()=>{state.widthCm=$('[data-cw-width]').value;});
    function nextHousehold(skip){
      const value=$('[data-cw-number]').value;
      const valid=Number.isInteger(Number(value))&&Number(value)>=1&&Number(value)<=999;
      $('[data-cw-number-error]').hidden=skip||valid;if(!skip&&!valid)return;
      state.number=skip?'':value;state.stage=2;paint();
      $('[data-cw-kind-wrap]').hidden=!models.some(m=>m.animal===state.animal&&Number(m.accessory));
    }
    $('[data-cw-number-next]').addEventListener('click',()=>nextHousehold(false));
    $('[data-cw-number-skip]').addEventListener('click',()=>nextHousehold(true));
    $('[data-cw-number]').addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();nextHousehold(false);}});
    $('[data-cw-show]').addEventListener('click',()=>{
      const values=[maxInput.value,$('[data-cw-width]').value];
      const valid=values.every(v=>v===''||(Number.isFinite(Number(v))&&Number(v)>0));
      $('[data-cw-space-error]').hidden=valid;if(!valid)return;
      state.maxCm=values[0];state.widthCm=values[1];state.stage=3;paint();$('[data-cw-results-title]').focus();
    });
    $('[data-cw-skip]').addEventListener('click', () => {
      state.maxCm = '';
      state.widthCm='';$('[data-cw-width]').value='';state.stage=3;
      maxInput.value = '';
      paint();
      $('[data-cw-results-title]').focus();
    });
    function reset() {
      state.animal = '';
      state.kind = 'housing';
      state.maxCm = '';
      state.widthCm='';state.number='';state.stage=0;$('[data-cw-width]').value='';
      maxInput.value = '';
      paint();
      animals.querySelector('button').focus();
    }
    back.addEventListener('click',()=>{state.stage=Math.max(0,state.stage-1);paint();});
    $('[data-cw-restart]').addEventListener('click', reset);
    paint();
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { select, previewUrl, reason, init };
  if (typeof document !== 'undefined') {
    const boot = () => document.querySelectorAll('[data-cw-find]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  }
})();
